import SettingsPartContainer from "./SettingsPartContainer";
import UICreatorComponent from "@baseUI/utils/UICreatorComponent";
import InfoSettingsPartArranger from "@baseUI/component/settings/InfoSettingsPartArranger";
import UIFacade from "@baseUI/UIFacade";

export default class InfoSettingsPartContainerPortrait extends SettingsPartContainer {
  constructor() {
    super()

    this.settings = {
      imageArranger: () => {},
      contentWidth: 900,
      chaptersGap: 30,
      fieldsGap: 15
    }

    this.settings.imageArranger = (image, chapter) => {
      image.x = 0;
      image.y = chapter.height - image.height;
    }

    this.panelPopup = UICreatorComponent.addScrollableContainer(this, {
      boxWidth: 1000,
      boxHeight: 1400,
      overflowX: "hidden",
      overflowY: "auto"
    })
  }

  updateText() {
    new InfoSettingsPartArranger().create(this.data, this.panelPopup, this.settings);
  }

  updateSize(uiModelView){
    this.panelPopup.boxHeight = uiModelView.shiftHeight * 1.4//+ 500 // 1900 + uiModelView.shiftY
  }

  get data() {
    return UIFacade.InfoChapters;
  }
}
